import axios from 'axios';
import Vue from 'vue'
import i18n from "@/i18n";

export default {
    getCustomers(countryId,cityId) {
        return axios.get('/api/customers/list', { params: {countryId:countryId,cityId:cityId} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },
    getCustomerInfo() {
        return axios.get('/api/customers/info')
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },
    saveCustomerProfile(customerInfo){
        return axios.post('/api/customers/save-profile', customerInfo)
        .then(response => {
            if (response && (response.data)) {
                Vue.prototype.$snotify.success('Modification enregistrée');
                return response.data
            }  
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },
    findCustomerById(customerId) {
        return axios.get('/api/customers/customerById', { params: {customerId:customerId} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getNoteTypes() {
        return axios.get('/api/customers/noteTypes')
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getNoteByCustomer(page, pageSize, customerId) {
        return axios.get('/api/customers/note/list', { params: {  page: page, pageSize: pageSize, customerId:customerId } })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },
    deleteCustomer(page, pageSize, customerId) {
        return axios.get('/api/customers/deleteCustomer',  { params: {  page: page, pageSize: pageSize, customerId:customerId} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    deleteNote(page, pageSize, noteId) {
      return axios.get('/api/customers/deleteNote',  { params: {  page: page, pageSize: pageSize, noteId:noteId} })
      .then(response => {
          if (response && response.data) return response.data
      })
      .catch(error => {Vue.prototype.$snotify.error(error);})
  },

    addNote(page, pageSize, note) {
        return axios.post('/api/customers/note', note , { params: {  page: page, pageSize: pageSize} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    saveCustomer(customer){
        return axios.post('/api/customers/add',customer)
        .then(response => {
          if (response && response.data) return response.data;
        })
        .catch(error => {
          Vue.prototype.$snotify.error(error);
        });
    },

    getInactiveCustomers (page, pageSize) {
        return axios.get('/api/customers/inactive-customers', { params: {  page: page, pageSize: pageSize } })
          .then(response => {
            if (response && response.data) return response.data
          })
          .catch(error => {Vue.prototype.$snotify.error(error);})
      },

      remindInactiveCustomer (customerId) {
        return axios.get('/api/customers/inactive-customers/remind', { params: {  customerId: customerId } })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },
    getAllInactiveCustomersIds(){
        return axios.post('/api/customers/inactive-customers/list')
        .then(response => {
          if (response && response.data) return response.data;
        })
        .catch(error => {
          Vue.prototype.$snotify.error(error);
        });
    },
      
      remindInactiveCustomers(customerIds) {
        return axios.post('/api/customers/inactive-customers/remind/all', customerIds)
          .then(response => {
            if (response && response.data) return response.data;
          })
          .catch(error => {
            Vue.prototype.$snotify.error(error);
          });
      },

    getAllCustomers (filter , page, pageSize,countryId,cityId) {
        return axios.get('/api/customers/custmerslist', { params: {  filter: filter,page: page, pageSize: pageSize, countryId:countryId,cityId:cityId} })
        .then(customersListDTO => {
            if (customersListDTO && customersListDTO.data) return customersListDTO.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getAllCustomersWithUsersCount (filter , page, pageSize,countryId,cityId) {
        return axios.get('/api/customers/custmerslist', { params: {  filter: filter,page: page, pageSize: pageSize, countryId:countryId,cityId:cityId, withUsersCount:true} })
        .then(customersListDTO => {
            if (customersListDTO && customersListDTO.data) return customersListDTO.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getCountCustomers(){
        return axios.get('/api/customers/count/customers')
        .then(response => {
            if (response && (response.data))   return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getOutstandingInfo () {
        return axios.get('/api/customers/outstandingInfo')
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    saveFilePDF(formData,id){
        return axios.post("/api/customers/uploadPaymentConditions/"+id, formData, {headers: {'Content-Type': 'multipart/form-data' }})
        .then(response => {
            if (response && response.data) {
                Vue.prototype.$snotify.success(i18n.t('services.customer.save'));
                return response.data;
            }
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    downloadPaymentConditions(fileName){
        axios({
            url:'/api/customers/getPaymentConditions',
            method: 'GET',
            params: {fileName:fileName } ,
            responseType: 'blob', // important
          }).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'file.pdf');
            document.body.appendChild(link);
            link.click();
          });
    },

    getCustomerCurrency(){
        return axios.get('/api/customers/currency')
        .then(response => {
            if (response && (response.data))   return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },
   
 
}

